import { useNavigate, useParams } from 'react-router'
import Spacing from '../componenets/UI/Spacing'
import { IoMdArrowForward } from 'react-icons/io'
import { useCallback, useEffect, useState } from 'react'
import axiosClient from '../config/axios-client'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

export default function FutureMineralsDetailsPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { mineral_slug, lng } = useParams()
  const [mineral, setMineral] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const handleOnClickBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  const getFutureMineralDetails = useCallback(() => {
    setIsLoading(true)
    axiosClient
      .get(`/platform/minerals/${mineral_slug}/details`)
      .then(({ data }) => {
        setMineral(data.mineral)
      })
      .catch((error) => {
        navigate(`/${lng}/not-found`, { replace: true })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [mineral_slug])

  useEffect(() => {
    getFutureMineralDetails()
  }, [getFutureMineralDetails])

  return (
    <div>
      <Helmet>
        <title>{`APFM | ${mineral ? mineral[`name_${lng}`] : ''}`}</title>
      </Helmet>
      <Spacing />
      <article className="app-container px-8 text-[18px] lg:px-0">
        <div className="mb-4 flex items-center gap-2">
          <button
            className="bg-primary-600 border-primary-600 hover:text-primary-600 hover:border-secondary-600 hover:bg-muted-300 border-2 p-3 text-white"
            onClick={handleOnClickBack}
          >
            <IoMdArrowForward className="h-6 w-6 ltr:rotate-180" />
          </button>
        </div>
        {isLoading ? (
          <div className="animate-pulse">
            <div className="bg-muted-300 mb-4 h-10 w-40" />
            <div className="bg-muted-300 mb-4 h-64 w-64" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-16 h-4 w-2/3" />
            <div className="bg-muted-300 mb-4 h-10 w-40" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-16 h-4 w-2/3" />
            <div className="bg-muted-300 mb-4 h-10 w-48" />
            <div className="bg-muted-300 mb-4 h-64 w-64" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-16 h-4 w-2/3" />
            <div className="bg-muted-300 mb-4 h-10 w-40" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-full" />
            <div className="bg-muted-300 mb-4 h-4 w-2/3" />
          </div>
        ) : (
          <>
            <h1 className="text-4xl font-bold">
              {mineral[`name_${lng}`]}{' '}
              {mineral.symbol && (
                <>
                  (<span className="text-secondary-600">{mineral.symbol}</span>)
                </>
              )}
            </h1>
            <div className="mb-2">
              <img
                title={mineral[`name_${lng}`]}
                className="h-64 w-64"
                src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral.image}`}
                alt={mineral[`name_${lng}`]}
              />
            </div>
            <p
              className="mb-16"
              dangerouslySetInnerHTML={{
                __html: mineral[`description_${lng}`],
              }}
            />
            <div className="mb-16 text-justify">
              <h2 className="mb-2 text-2xl font-bold">
                {t('FUTURE_MINERAL_HISTORY')} {mineral[`name_${lng}`]}
              </h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: mineral[`history_description_${lng}`],
                }}
              />
            </div>
            <div className="mb-16 text-justify">
              <h2 className="mb-2 text-2xl font-bold">{t('FUTURE_MINERAL_SOURCE').replace('####', mineral[`name_${lng}`])}</h2>
              <div className="mb-2">
                <img
                  className="h-64 w-64"
                  src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral.source_image}`}
                  alt="source_image"
                />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: mineral[`source_description_${lng}`],
                }}
              />
            </div>
            {mineral[`compound_description_${lng}`] && (
              <div className="text-justify">
                <h2 className="mb-2 text-2xl font-bold">{t('FUTURE_MINERAL_COMPOUNDS').replace('####', mineral[`name_${lng}`])}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: mineral[`compound_description_${lng}`],
                  }}
                />
              </div>
            )}
            {mineral.studies_link && (
              <div className={`mt-16`}>
                <h4 className={`mb-1 font-bold`}>{t('FOR_MORE_INFORMATION')}</h4>
                {/* Link to studies file */}
                <Link
                  target={`_blank`}
                  className={`hover:underline-none hover:text-secondary-600`}
                  to={mineral.studies_link}
                >
                  {t('DOWNLOAD_STUDIES_FILE')}
                </Link>
              </div>
            )}
          </>
        )}
      </article>
    </div>
  )
}
